import { styled } from '@mui/material/styles'
import { Box, Card, Grid, Typography } from '@mui/material'

import { theme } from 'theme'

interface MiscTextProps {
  color?: any
  fontSize?: string
  fontWeight?: number | string
}

interface TextButtonProps {}

export const TextButton = styled(Typography)((props: TextButtonProps) => ({
  fontSize: '13px',
  padding: 2,
  fontFamily: 'NotoSans',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
}))

export const MiscText = styled(Typography)(
  ({ color, fontSize, fontWeight }: MiscTextProps) => ({
    fontSize: fontSize ?? '14px',
    color: color ?? theme.palette.text.disabled,
    fontWeight: fontWeight ?? 200,
    fontFamily: 'NotoSans'
  })
)

interface BlockContainerProps {
  loading: number
}

export const BlockContainer = styled(Grid)(
  ({ loading }: BlockContainerProps) => ({
    height: 'wrap-content',
    flexDirection: 'column',
    justifyContent: 'center',

    pointerEvents: loading === 1 ? 'none' : 'all'
  })
)

export const PhoneTypePicker = styled(Box)<{
  selected?: boolean
}>(({ theme, selected }) => ({
  borderTopLeftRadius: '25px',
  borderBottomLeftRadius: '25px',
  minWidth: '40px',
  width: '40px',
  height: '100%',
  cursor: 'pointer',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderLeft: '1px solid #B9B9B9',
  borderBottom: '1px solid #B9B9B9',
  borderTop: '1px solid #B9B9B9',
  background: selected ? '#fff' : '#F5F5F5',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',

  padding: theme.spacing(0, 2),

  '&:hover': {
    backgroundColor: '#fff'
  }
}))

export const PhoneTypeContainer = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  cursor: 'pointer',
  gap: 16,
  marginTop: 8,
  padding: theme.spacing(0, 4),
  alignItems: 'flex-start',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: '#f5f5f5'
  }
}))

export const PhoneTypeText = styled(Typography)(() => ({
  color: '#000000',
  letterSpacing: '0.00938em',
  fontFeatureSettings: "'clig' off, 'liga' off",
  fontFamily: 'NotoSans',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '1.15625rem' /* 115.625% */
}))

export const PhoneTypeMisc = styled(PhoneTypeText)(() => ({
  fontSize: '0.85rem',
  fontWeight: 300,
  lineHeight: '1.0625rem' /* 106.25% */
}))
